/* Breadcrumb navigation context (snippets/kg-breadcrumbs.liquid).
   Product URLs stay /products/handle, so the collection a shopper came from is remembered here, in
   sessionStorage "kgBc" (this tab only):
     k = explicit context: a product link clicked inside a collection grid ([data-kg-bc-ctx])
         { p: product handle, c: collection handle, q: the grid's filter/sort/page query, t: time }
     l = journey: the collection listing being browsed { c, q, t }
   The product page's inline script uses k only for that product and l only if the product belongs to
   that collection, both for 30 minutes; it can only choose among trails the server rendered.
   Any page other than a collection or product page ends the journey, so search results, the home page
   etc. never inherit an old category. Also runs the phone "…" button that unfolds the full trail. */
(function () {
  if (window.KgBc) return;
  window.KgBc = true;

  var KEY = 'kgBc';

  function read() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function write(s) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) {}
  }

  function query() {
    var q = location.search;
    return q.length < 600 ? q : '';
  }

  var main = document.querySelector('main[data-template]');
  var template = (main && main.getAttribute('data-template')) || '';
  var state = read();

  if (/^collection/.test(template)) {
    var grid = document.querySelector('[data-kg-bc-ctx]');
    if (grid) state.l = { c: grid.getAttribute('data-kg-bc-ctx'), q: query(), t: Date.now() };
    else delete state.l;
    write(state);
  } else if (!/^product/.test(template)) {
    if (state.l || state.k) write({});
  }

  function onLink(e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.origin !== location.origin) return;
    var m = a.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var s = read();
    var box = a.closest('[data-kg-bc-ctx]');
    if (box) {
      var c = box.getAttribute('data-kg-bc-ctx'), q = query(), t = Date.now(), p = m[1];
      try {
        p = decodeURIComponent(p);
      } catch (err) {}
      s.k = { p: p, c: c, q: q, t: t };
      s.l = { c: c, q: q, t: t };
    } else {
      delete s.k;
    }
    write(s);
  }

  document.addEventListener('click', onLink, true);
  document.addEventListener('auxclick', onLink, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kg-bc-more]');
    if (!btn) return;
    var nav = btn.closest('.kg-bc');
    if (!nav) return;
    nav.classList.add('is-expanded');
    btn.setAttribute('aria-expanded', 'true');
    var first = nav.querySelector('.kg-bc__item--fold a');
    if (first) first.focus();
  });
})();
